export enum ETemplatePreExam {
  LyDoVaoVien = 'Lý do vào viện',
  DiUng = 'Dị ứng',
  TienCanBanThan = 'Tiền căn bản thân',
  TienCanGiaDinh = 'Tiền căn gia đình',
  BenhSu = 'Bệnh sử',
  GiaDinh = 'Gia đình',
  BanThan = 'Bản thân'
}
